import {ArenaGameFilterBase} from "./arena-game-filter-base";
import {IArenaGameFilter} from "./arena-game-filter.interface";

export class StaticArenaGameFilter extends ArenaGameFilterBase{
    get subFilters(): IArenaGameFilter[] {
        return [];
    }
}
